
<table class="w-full border-separate border-spacing-0 table-auto [&_td]:!border-[#EDE9E3]">
  <thead>
    <tr>
      <th/>
      <th
        class="!p-2 !text-center !align-middle text-[1rem] leading-[2rem] bg-[#EEF4FF] border-[#3565FC] border-b-2 !font-medium rounded-t-lg"
      >
        Cubic Capacity
      </th>
      <th/>
      <th
        class="!p-2 !text-center !align-middle text-[1rem] leading-[2rem] bg-[#FEFCE8] border-[#EAB308] border-b-2 !font-medium rounded-t-lg"
      >
        Tare Weight
      </th>
      <th/>
      <th
        class="!p-2 !text-center !align-middle text-[1rem] leading-[2rem] bg-[#ECFEFF] border-[#06B6D4] border-b-2 !font-medium rounded-t-lg"
      >
        Max Gross
      </th>
      <th />
      <th
        class="!p-2 !text-center !align-middle text-[1rem] leading-[2rem] bg-[#FFF7ED] border-[#F97316] border-b-2 !font-medium rounded-t-lg"
      >
        Max Payload
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(containerTypeSize, index) in filteredContainerTypeSizesByCubicCapacity"
      :key="containerTypeSize.name"
      class="even:bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]"
    >
      <td class="!font-medium border-t">{{ containerTypeSize.name }}</td>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-b-lg border-b': index === filteredContainerTypeSizesByCubicCapacity.length - 1 }
        ]"
      >
        <p class="p-0 m-0">
          {{ containerTypeSize.cubicCapacity }}
        </p>
        <p
          v-if="!!containerTypeSize.liquidCubicCapacity"
          class="p-0 m-0 opacity-60 text-[0.625rem] leading-[0.625rem]"
        >
          ({{ containerTypeSize.liquidCubicCapacity }})
        </p>
      </td>
      <td class="!p-0"/>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-b-lg border-b': index === filteredContainerTypeSizesByCubicCapacity.length - 1 }
        ]"
      >
        {{ containerTypeSize.tareWeight }}
      </td>
      <td class="!p-0"/>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-b-lg border-b': index === filteredContainerTypeSizesByCubicCapacity.length - 1 }
        ]"
      >
        {{ containerTypeSize.maxGross }}
      </td>
      <td class="!p-0"/>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-b-lg border-b': index === filteredContainerTypeSizesByCubicCapacity.length - 1 }
        ]"
      >
        {{ containerTypeSize.maxPayload }}
      </td>
    </tr>
  </tbody>
</table>
